export enum ConduzioneStallaEnum {
  PROPRIETA = 'Proprietà',
  AFFITTO = 'Affitto',
}
